module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/hero-29c05ee3cce4a99a6222b891b37c0674.jpg";